import ApiIcon from '@mui/icons-material/HubOutlined';
import WebIcon from '@mui/icons-material/WebOutlined';
import StorageIcon from '@mui/icons-material/StorageOutlined';
import CloudIcon from '@mui/icons-material/CloudOutlined';
import { useTilt } from '../utility/motion';

const GROUPS = [
    {
        id: 'backend',
        icon: ApiIcon,
        title: 'Backend',
        description: { it: 'Microservizi, API REST e sistemi enterprise.', en: 'Microservices, REST APIs and enterprise systems.' },
        skills: [
            { name: 'Java', level: 95, color: '#f89820' },
            { name: 'Spring Boot', level: 90, color: '#6db33f' },
            { name: 'REST APIs', level: 92, color: '#a78bfa' },
            { name: 'Node.js', level: 80, color: '#68a063' },
        ],
    },
    {
        id: 'frontend',
        icon: WebIcon,
        title: 'Frontend & Cloud',
        description: { it: 'Interfacce moderne e servizi cloud.', en: 'Modern interfaces and cloud services.' },
        skills: [
            { name: 'React', level: 85, color: '#61dafb' },
            { name: 'Firebase', level: 78, color: '#ffca28' },
            { name: 'Google Cloud', level: 76, color: '#4285f4' },
        ],
    },
    {
        id: 'data',
        icon: StorageIcon,
        title: 'Database',
        description: { it: 'Modellazione dati relazionale e NoSQL.', en: 'Relational and NoSQL data modelling.' },
        skills: [
            { name: 'MySQL', level: 88, color: '#00a3c4' },
            { name: 'IBM DB2', level: 85, color: '#3b82f6' },
            { name: 'MongoDB', level: 80, color: '#47a248' },
        ],
    },
    {
        id: 'cloud',
        icon: CloudIcon,
        title: 'DevOps & Tools',
        description: { it: 'Versionamento, container e deploy.', en: 'Versioning, containers and deployment.' },
        skills: [
            { name: 'Git', level: 85, color: '#f05032' },
            { name: 'Docker', level: 75, color: '#2496ed' },
        ],
    },
];

function SkillCard({group, checked, index}) {
    const ref = useTilt(6);
    const GroupIcon = group.icon;
    return (
        <article
            ref={ref}
            className={`skill-card card tilt skill-card--${group.id}`}
            data-reveal
            style={{ '--d': `${index * 100}ms` }}
        >
            <span className="card__spotlight" aria-hidden="true" />
            <header className="skill-card__head">
                <span className="skill-card__icon"><GroupIcon /></span>
                <div>
                    <h3 className="skill-card__title">{group.title}</h3>
                    <p className="skill-card__desc">{checked ? group.description.it : group.description.en}</p>
                </div>
            </header>
            <ul className="skill-card__list">
                {group.skills.map((skill, skillIndex) => (
                    <li key={skill.name} className="skill" style={{ '--c': skill.color, '--lvl': `${skill.level}%`, '--sd': `${skillIndex * 90 + 250}ms` }}>
                        <span className="skill__row">
                            <span className="skill__name"><span className="skill__dot" aria-hidden="true" />{skill.name}</span>
                            <span className="skill__level mono">{skill.level}</span>
                        </span>
                        <span className="skill__bar" aria-hidden="true"><span className="skill__fill" /></span>
                    </li>
                ))}
            </ul>
        </article>
    );
}

function Skills({checked}) {
    return (
        <section className="section skills" id="skills" aria-labelledby="skills-title">
            <div className="section__head" data-reveal>
                <span className="eyebrow">{checked ? 'Competenze' : 'Skills'}</span>
                <h2 className="section__title" id="skills-title">
                    {checked ? 'Gli strumenti del mestiere' : 'Tools of the trade'}
                </h2>
                <p className="section__lead">
                    {checked
                        ? 'Dal database all’interfaccia: le tecnologie che uso ogni giorno, al lavoro e nei miei progetti.'
                        : 'From database to interface: the technologies I use every day, at work and in my own projects.'}
                </p>
            </div>

            <div className="skills__grid">
                {GROUPS.map((group, index) => (
                    <SkillCard key={group.id} group={group} checked={checked} index={index} />
                ))}
            </div>
        </section>
    );
}

export default Skills;
